<script lang="ts">
	import type { ClassValue, MouseEventHandler } from "svelte/elements";
	import arrowIcon from "@core/assets/icons/arrow.svg?raw";
	import { tw } from "@core/utils/svelte/tw.js";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./ProductDetailFathersFamilyBanner.translations.json" with { type: "json" };
	import Formatted from "./common/Formatted.svelte";
	import Icon from "./common/Icon.svelte";

	const translate = getTranslate(translations);

	const {
		heading,
		label,
		action,
		class: customClass,
	}: {
		heading: string;
		label: string;
		class?: ClassValue;
		action: MouseEventHandler<HTMLButtonElement> | { href: string };
	} = $props();

	const actionClasses = tw(
		"bg-white enabled:hover:bg-white/80 text-fcrdarkgray size-16 flex justify-center items-center rounded-full",
		"[&:not(:disabled):hover:active]:scale-95 transition duration-150 ease-in-out",
		"[&:not(:disabled):hover]:outline-fcrdarkgray/25 [&:not(:disabled):hover]:outline",
	);
</script>

<div class={["flex items-center p-6 gap-4", customClass]}>
	<div class="grow shrink flex flex-col gap-2">
		<div class="font-antipol font-medium text-white text-xl">
			<Formatted text={heading} />
		</div>
		<div class="text-fcrlightgray text-sm">
			<Formatted text={label} />
		</div>
	</div>
	<div class="grow-0 shrink-0">
		{#if typeof action === "function"}
			<button type="button" class={actionClasses} onclick={action} aria-label={translate("learnMore")}>
				<Icon icon={arrowIcon} class="size-4 text-fcrdarkgray" />
			</button>
		{:else}
			<a class={actionClasses} href={action.href} aria-label={translate("learnMore")}>
				<Icon icon={arrowIcon} class="size-4 text-fcrdarkgray" />
			</a>
		{/if}
	</div>
</div>
